export const darkModePallete = {
    textColor: { color: "white" },
    legendTextColor:{color:"#E5E4E2"},
    primaryBackground: { backgroundColor: "#121212" },
    secondaryBackground: { backgroundColor: "#1F1F1F" },
    tertiaryBackground: { backgroundColor: "#353434" },
    btnBlue: { backgroundColor: "#0159A1" },
    icon: { filter: 'invert(100%)' },
    shadow: { boxShadow: "none" }
}